export default "__VITE_ASSET__8451e872__"